import './survey_mocks';
import loadable from '@loadable/component';
import { SurveyJSWidget } from './components/manage/Widgets';
import { defineMessages } from 'react-intl';
import {
  AreaPersonaleView,
  AreaOperatoreView,
  ModelloPraticaView,
} from './components/View';
import {
  creatorJson,
  creatorOptions,
  removeProperties,
  hideProperties,
} from './config/creator';
import {
  praticaRecord,
  listPratiche,
  praticaWorkflow,
} from './reducers/record';
import { listOperatori } from './reducers/operatori';
import { listMessages, ioCittadinoMessage } from './reducers/messages';
import { postBlob } from './actions/blob';
import { paymentURl } from './reducers/pagamenti';

const messages = defineMessages({
  areapersonale_title: {
    id: 'areapersonale_title',
    defaultMessage: 'Area personale',
  },
  areaoperatore_title: {
    id: 'areaoperatore_title',
    defaultMessage: 'Area operatore',
  },
});

const applyConfig = (config) => {
  config.widgets.id.pratica_model = SurveyJSWidget;

  config.views.contentTypesViews.ModelloPratica = ModelloPraticaView;

  // TODO: verificare se serve che siano loadable, dal momento che dovfrebbero
  // essere già loadable le componenti che li usano
  config.settings.loadables = {
    ...config.settings.loadables,
    surveyCreatorReact: loadable.lib(() => import('survey-creator-react')),
    surveyReactUI: loadable.lib(() => import('survey-react-ui')),
    surveyCore: loadable.lib(() => import('survey-core')),
    surveyCoreI18n: loadable(() => import('survey-core/survey.i18n')),
    surveyCreatorCoreI18n: loadable(
      () => import('survey-creator-core/survey-creator-core.i18n.js'),
    ),
  };

  config.settings['volto-io-cittadino'] = {
    creatorJson,
    creatorOptions,
    removeProperties,
    hideProperties,
  };

  config.addonReducers = {
    ...config.addonReducers,
    praticaRecord,
    listPratiche,
    listOperatori,
    listMessages,
    ioCittadinoMessage,
    praticaWorkflow,
    postBlob,
    paymentURl,
  };

  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '/area-personale-cittadino',
      component: AreaPersonaleView,
      exact: true,
    },
    {
      path: '/area-personale-operatore',
      component: AreaOperatoreView,
      exact: true,
    },
  ];

  config.settings.nonContentRoutes = [
    ...config.settings.nonContentRoutes,
    // /\/area-personale-operatore\/.*$/,
    '/area-personale-operatore',
    /\/area-personale-cittadino\/.*$/,
    '/area-personale-cittadino',
  ];

  config.settings.siteProperties.userLoggedMenu = [
    ...(config.settings.siteProperties.userLoggedMenu || []),
    {
      href: { it: '/area-personale-cittadino' },
      title: { it: 'Area personale' },
      roles: ['Citizen'],
      className: 'link-areaPersonale',
    },
    {
      href: { it: '/area-personale-operatore' },
      title: { it: 'Area operatore' },
      roles: ['Gestore Pratiche'],
      className: 'link-areaOperatore',
    },
  ];

  config.settings.siteProperties.enableNoFeedbackFormFor = true;

  config.settings['volto-feedback'] = {
    ...config.settings['volto-feedback'],
    /* Enable Feedback component in your CMS/Non content routes. */
    feedbackEnabledNonContentRoutes: [
      ...config.settings['volto-feedback'].feedbackEnabledNonContentRoutes,
      {
        path: '/area-personale-cittadino',
        feedbackTitle: messages.areapersonale_title,
      },
      {
        path: '/area-personale-operatore',
        feedbackTitle: messages.areaoperatore_title,
      },
    ],
  };

  return config;
};

export default applyConfig;
